import { render, staticRenderFns } from "./ShopSetting.vue?vue&type=template&id=79b7affd&scoped=true&lang=pug&"
import script from "./ShopSetting.vue?vue&type=script&lang=js&"
export * from "./ShopSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShopSetting.vue?vue&type=style&index=0&id=79b7affd&lang=scss&scoped=true&"
import style1 from "./ShopSetting.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b7affd",
  null
  
)

export default component.exports